import axios, { buildApi } from '@/libs/api.request';
let name = ''

export const apis = buildApi({
  put: ['/api/shipment/rollback',],
})